import Rails from "@rails/ujs";
import jQuery from "jquery";
jQuery.fn["submit"] = function(data, fn) {
  if (arguments.length > 0) {
    this.on("submit", null, data, fn);
  } else {
    this.each((_index, el) => {
      const eventWasNotHandled = Rails.fire(el, "submit");
      if (eventWasNotHandled) el.submit();
    });
  }
  return this;
};
